import { BottomNudgeRs, CenterNudgeRs, TopNudgeRs } from '@domain/rs/NudgeRs';
import { NUDGE_RS_TYPE } from '@domain/constant/nudgeType';
import { getFileImg } from '@utils/common';

export class TopNudgeVO {
  hasPath: boolean;
  type: NUDGE_RS_TYPE.TOP_BANNER;
  thumbnailImageImgPath: string;
  previewImageImgPath: string;
  link: string;
  pathList: string[];
  backgroundColor: string;

  constructor(rs: TopNudgeRs) {
    this.hasPath = rs.hasPath;
    this.type = rs.type;
    // TODO: 기본 이미지 필요
    this.thumbnailImageImgPath = rs.thumbnailImageUid ? getFileImg(rs.thumbnailImageUid) : '';
    // TODO: 기본 이미지 필요
    this.previewImageImgPath = rs.previewImageUid ? getFileImg(rs.previewImageUid) : '';
    this.link = rs.link;
    this.pathList = rs.pathList;
    this.backgroundColor = rs.color;
  }
}

export class BottomNudgeVO {
  sn: number;
  hasPath: boolean;
  type: NUDGE_RS_TYPE.BOTTOM_BANNER;
  thumbnailImageImgPath: string;
  link: string;
  pathList: string[];

  constructor(rs: BottomNudgeRs) {
    this.sn = rs.sn;
    this.hasPath = rs.hasPath;
    this.type = rs.type;
    // TODO: 기본 이미지 필요
    this.thumbnailImageImgPath = rs.thumbnailImageUid ? getFileImg(rs.thumbnailImageUid) : '';
    this.link = rs.link;
    this.pathList = rs.pathList;
  }
}

export class CenterNudgeVO {
  hasPath: boolean;
  type: NUDGE_RS_TYPE.CENTER_BANNER;
  thumbnailImageImgPath: string;
  link: string;
  pathList: string[];
  priority: number;

  constructor(rs: CenterNudgeRs) {
    this.hasPath = rs.hasPath;
    this.type = rs.type;
    // TODO: 기본 이미지 필요
    this.thumbnailImageImgPath = rs.thumbnailImageUid ? getFileImg(rs.thumbnailImageUid) : '';
    this.link = rs.link;
    this.pathList = rs.pathList;
    this.priority = rs.priority;
  }
}
